import React from "react";
import styled from "styled-components";
import variables from "../../../constants/assets/variables";
import Table from "../../Common/Table";
import TableFields from "../../../constants/Orders/TableFields.json";
import { useHistory } from "react-router-dom";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as OrdersActions from "../../../store/actions/Orders";

const OrdersListTable = ({ list = [], resetOrderDetails }) => {
  const history = useHistory();
  const getFieldValue = (item, key) => {
    switch (key) {
      case "order_id":
        return (
          <span
            onClick={(event) => handleRowClick(item, event)}
            className="edit-options"
          >
            {item.order_id}
          </span>
        );
      default:
        return item[key];
    }
  };

  const handleRowClick = (item, event) => {
    if (event.metaKey) {
      // Open in a new tab
      event.preventDefault(); // Prevents the default navigation behavior
      const url = `/orders/${item.order_id}`;
      window.open(window.location.origin + url, "_blank");
    } else {
      resetOrderDetails();
      // Navigate in the current tab
      history.push(`/orders/${item.order_id}`);
    }
  };

  return (
    <PartnersListTableContainer>
      {list.length > 0 ? (
        <Table
          fontSize="0.75rem"
          list={list}
          fields={TableFields}
          getFieldValue={getFieldValue}
        />
      ) : (
        <div />
      )}
    </PartnersListTableContainer>
  );
};

const PartnersListTableContainer = styled.div`
  background: ${variables.white};
  border: 0.5px solid ${variables.grey300};
  box-sizing: border-box;
  border-radius: 8px;
  height: 100%;
`;

function mapDispatchToProps(dispatch) {
  return {
    resetOrderDetails: bindActionCreators(
      OrdersActions.resetOrderDetails,
      dispatch
    ),
  };
}

export default connect(null, mapDispatchToProps)(OrdersListTable);
